import {
  getGrahakAuthSurfaceFromState,
  isEligibleforGrahakRuleFromState,
  GrahakAuthSurface,
} from 'shared/api/grahakAuthSurface';

type StateReader = () => any;

let grahakAuthStateReader: StateReader | null = null;

export const setGrahakAuthStateReader = (reader: StateReader | null): void => {
  grahakAuthStateReader = reader;
};

const getCurrentState = () => {
  try {
    return grahakAuthStateReader ? grahakAuthStateReader() : undefined;
  } catch (e) {
    return undefined;
  }
};

export const getCurrentGrahakAuthSurface = (): GrahakAuthSurface | null =>
  getGrahakAuthSurfaceFromState(getCurrentState());

export const isCurrentUserEligibleForGrahak = (): boolean =>
  isEligibleforGrahakRuleFromState(getCurrentState());
